import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'

export default ({ app }) => {
  Vue.use(VueAwesomeSwiper /* { default options with global component } */)
}
